import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import Plane from '../../../../assets/icons/verification/plane.svg';
import { useNavigationStack } from '../../../../context/NavigationStackContext';
import { useFirebaseAuth } from '../../../../hooks/useFirebaseAuth';
import { Paths } from '../../../../shared/paths';
import { handleAuthError } from '../../../../utils/auth/auth-errors';
import AppButton from '../../../designe/buttons/app-button/AppButton';
import { successToastMessage } from '../../../layout/toast-root/toast';
import CommonErrorPage from '../CommonErrorPage/CommonErrorPage';

const NotVerifiedPage = () => {
  const { t } = useTranslation();
  const { navigate } = useNavigationStack();
  const [sendingEmailState, setSendingEmailState] = React.useState(false);
  const [isSending, setIsSending] = React.useState(false);
  const { sendVerificationEmail } = useFirebaseAuth();

  async function onSendEmailClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    e.stopPropagation();
    setIsSending(true);
    try {
      await sendVerificationEmail();
      successToastMessage(t('forgotPassword.emailSentMessage'));
      setSendingEmailState(true);
    } catch (error: unknown) {
      handleAuthError(error, t);
    } finally {
      setIsSending(false);
    }
  }

  return (
    <CommonErrorPage
      errorImage={Plane}
      title={t('errorPages.notVerified.title')}
      description={t('verification.checkEmail')}
      buttonText={t('common.goToSignIn')}
      onClick={() => navigate(Paths.signIn)}>
      <Box marginBottom={1} marginTop={1}>
        {!sendingEmailState && (
          <AppButton
            type="button"
            sx={(theme) => ({
              fontSize: 14,
              fontWeight: 700,
              color: theme.palette.common.white,
              backgroundColor: theme.palette.primary.main,
            })}
            variant="contained"
            loading={isSending}
            onClick={onSendEmailClick}>
            {t('common.resendTheEmail')}
          </AppButton>
        )}
      </Box>
    </CommonErrorPage>
  );
};

export default NotVerifiedPage;
